import Plyr from 'plyr'


const player = new Plyr('#player', {
  controls: ['progress', 'current-time','duration', 'mute', 'volume', 'captions', 'pip', 'airplay', 'fullscreen']
})

window.addEventListener('DOMContentLoaded', function (e) {
  let rewind = document.querySelector('.rewind')
  let forward = document.querySelector('.forward')
  let play = document.querySelector('.play')
  let iconPause = play.querySelector('.icon-pause')
  let iconPlay = play.querySelector('.icon-play')
  rewind.addEventListener('click', function (e) {
    player.rewind(10)
  })
  forward.addEventListener('click', function (e) {
    player.forward(10)
  })
  play.addEventListener('click', function (e) {
    player.togglePlay()
    iconPause.classList.toggle('hidden')
      iconPlay.classList.toggle('hidden')
  })
})
